import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useUserRole = () => {
  const query = useQuery({
    queryKey: [QueryKeys.USER_ROLE],
    queryFn: accountRepo.getRole,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseUserRole = ReturnType<typeof useUserRole>;
